export const BASE_PATH = '/tv-internet';
